import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BackButton from 'components/BackButton';
import KeyboardSmall from 'components/keyboard-small';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import { StyledBlock, StyledTitle, StyledDescription } from '../StyledComponents';
import ActionsSection from '../ActionsSection';
import i18n from 'i18n';
import { padEnd } from 'lodash';
import { StyledPinInputChar } from 'components/Modal/StyledComponents';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const MAX_PIN_LENGTH = 4;
const PIN_CODE_CHAR_PLACEHOLDER = '_';

export default class ParentalLockPinPage extends Component {
  state = {
    pin: '',
    isPinValid: true,
    isKeyboardVisible: true,
  };

  onBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  showKeyboard = () => {
    const { setPinError } = this.props;
    this.setState({ isKeyboardVisible: true, isPinValid: true }, () => {
      setPinError(null);
      SpatialNavigationWrapper.focus('@KEYBOARD_NUM');
    });
  };

  hideKeyboard = () => this.setState({ isKeyboardVisible: false });

  onButtonClick = () => {
    if (!this.isPinComplete()) {
      this.setState({ isPinValid: false });
      return;
    }

    const { history, setPin, pin: oldPin } = this.props;
    const { pin } = this.state;

    setPin(pin, oldPin, () => {
      innerAnalyticsVolia.postEvent({
        eventGroup: 'profile',
        eventName: `click PIN change`,
      });

      history.goBack();
    });
  };

  onKeyboardInput = (value) => {
    if (value === 'remove') {
      this.setState((state) => ({ pin: state.pin.slice(0, -1) }));
    } else if (value === 'close') {
      this.setState({ isKeyboardVisible: false, isPinValid: this.isPinComplete() }, () => {
        SpatialNavigationWrapper.focus('@PIN_NUMBER_INPUT');
      });
    } else if (!this.isPinComplete()) {
      this.setState((state) => ({ pin: state.pin + value }));
    }
  };

  isPinComplete = () => this.state.pin.length === MAX_PIN_LENGTH;

  renderPinCodeChar = (char, idx) => {
    const cursorPosition = this.state.pin.length;
    const isPlaceholder = char === PIN_CODE_CHAR_PLACEHOLDER;
    const isActive = idx === cursorPosition;

    return (
      <StyledPinInputChar key={idx} isActive={isActive} isPlaceholder={isPlaceholder}>
        {char}
      </StyledPinInputChar>
    );
  };

  render() {
    const { error } = this.props;
    const { isKeyboardVisible, isPinValid, pin } = this.state;
    const { showKeyboard, hideKeyboard, onButtonClick } = this;
    const cursorPosition = pin.length;

    return (
      <>
        <BackButton onEnter={this.onBack} />
        <div>
          <StyledBlock>
            <StyledTitle>{i18n.t('pc.pinChange')}</StyledTitle>
          </StyledBlock>
          <StyledBlock>
            <StyledDescription>{i18n.t('pc.pinCreateNew')}</StyledDescription>
          </StyledBlock>
          <StyledBlock>
            <ActionsSection sectionName="PIN_NUMBER_INPUT" defaultSection>
              <ActionsSection.Input
                value={padEnd(pin, MAX_PIN_LENGTH, PIN_CODE_CHAR_PLACEHOLDER)}
                isValid={!error && isPinValid}
                invalidMessage={error || i18n.t('pc.pinError')}
                cursor={isKeyboardVisible}
                cursorPosition={cursorPosition}
                onEnter={showKeyboard}
                renderCharacter={this.renderPinCodeChar}
              />
              <ActionsSection.Button
                label={i18n.t('pc.pinSaveButton')}
                onEnter={onButtonClick}
                onFocus={hideKeyboard}
              />
            </ActionsSection>
            {isKeyboardVisible && (
              <KeyboardSmall
                className="keyboard-small__phone"
                onEnter={this.onKeyboardInput}
                config={{
                  leaveFor: {
                    left: '@PIN_NUMBER_INPUT',
                    right: '',
                    up: '',
                    down: '',
                  },
                }}
              />
            )}
          </StyledBlock>
        </div>
      </>
    );
  }
}

ParentalLockPinPage.propTypes = {
  setPin: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  pin: PropTypes.string,
};
